'use client'
import { LogInIcon } from 'lucide-react'
import { cn } from '@/services/utils/cn'
import Link from 'next/link'
import { getSignInLink } from '@/config/links'
import { useEffect, useState } from 'react'
import { useAuth } from '@/services/providers/auth-provider'

export function SignInButton() {
  const auth = useAuth()
  const [isAuthenticated, setIsAuthenticated] = useState(auth.isAuthenticated())

  useEffect(() => {
    const checkAuthentication = async () => {
      const authenticated = await auth.isAuthenticated()
      setIsAuthenticated(authenticated)
    }

    checkAuthentication()
  }, [auth])

  const accessToken = auth.getTokens().accessToken

  if (auth.loading && accessToken) {
    return (
      <button
        className="relative z-50 flex cursor-not-allowed gap-2 rounded-full bg-black/10 px-4 py-2 font-line text-base font-normal text-black/30"
        disabled
      >
        กำลังโหลด...
      </button>
    )
  }

  return (
    <Link
      className={cn(
        'relative z-50 gap-2 rounded-full border border-black bg-black px-4 py-2 font-line text-base text-white hover:underline',
        isAuthenticated ? 'hidden' : 'flex'
      )}
      href={getSignInLink('/')}
    >
      เข้าสู่ระบบ
      <LogInIcon className="h-5 w-5" />
    </Link>
  )
}
